<template>
    <v-container fluid class="text-xs-center"> 
        <v-layout row wrap>
                <span class="field-title">Nome</span>
                <span class="field-value">{{pet.name}}</span><br>
                <span class="field-title">Specie</span>
                <span class="field-value">{{pet.species}}</span><br>
                <span class="field-title">Razza</span>
                <span class="field-value">{{pet.breed}}</span><br>
                <span class="field-title">Dimensioni</span>
                <span class="field-value">{{pet.size}}</span><br>
                <span class="field-title">Peso</span>
                <span class="field-value">{{pet.weight}}</span><br>
                <span class="field-title">Microchip</span>
                <span class="field-value">{{pet.microchip}}</span><br>
                <span class="field-title">Compleanno</span>
                <span class="field-value">{{pet.birthday | date}}</span><br>
                <span class="field-title">Data vaccinazione</span>
                <span class="field-value">{{pet.vaccinationDate | date}}</span><br>
                <span class="field-title">Data antiparassitario</span>
                <span class="field-value">{{pet.antiparasiticDate | date}}</span><br>
                <span class="field-title">Compatibilità</span>
                <span class="field-value">{{pet.compatibility}}</span><br>
                <span class="field-title">Patologie</span>
                <span class="field-value">{{pet.pathologies}}</span><br>
                <span class="field-title">Note</span>
                <span class="field-value">{{pet.notes}}</span><br>
                <span class="field-title">Ultima modifica</span>
                <span class="field-value">{{pet.lastEdit | datetime}}</span><br>
        </v-layout>
        <v-dialog
            v-model="showDeletionDialog"
            width="500"
        >
            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                    Conferma eliminazione
                </v-card-title>
                <v-card-text>
                    Vuoi davvero cancellare questo animale?
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    text
                    @click="showDeletionDialog = false"
                >
                    No, annulla
                </v-btn>
                <v-btn
                    color="red"
                    style="color:white"
                    text
                    @click="deletePet();showDeletionDialog = false"
                >
                    Si, elimina
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-btn
            dark
            absolute
            bottom
            right
            fab
            style="bottom:20px;"
            @click="$router.push({name: 'petEdit', params:{petId:pet.id}});"
            > <v-icon style="font-size:40px;padding-top:5px;">edit</v-icon>
        </v-btn>
        <v-btn
            color="#f44336"
            dark
            absolute
            bottom
            left
            fab
            @click.native="showDeletionDialog=true"
            style="bottom:20px;"
            > <v-icon style="font-size:40px;padding-top:5px;">delete</v-icon>
        </v-btn>
        <v-snackbar v-model="showDeletedToast">
            Animale eliminato!
        </v-snackbar>
    </v-container>
</template>

<script>
const axios = require('axios').default;
export default {
    name: 'Pet',
    data: function(){
        return{
            showDeletionDialog: false,
            showDeletedToast: false,
            searchedText: "",
            pet:{}
        };
    },
    mounted: function(){
        let vm = this;
        vm.getPet();
    },
    methods:{
        getPet(){
            let vm = this;
            axios({
                method: "GET",
                url: vm.$API_BASE_URL + "getPet.php?petId="+vm.$route.params.petId,
                headers: {
                    'Authentication-Token': window.localStorage.getItem("sogno_at")
                }
            })
            .then(function (response) {
                if (response.status == 200) {
                    vm.pet = response.data.resource;
                } 
                else{
                    alert("Si è verificato un errore durante il caricamento");
                }
            })
            .catch(function (error) {
                if(error.response.status==403||error.response.status==401){
                    vm.$router.push({name: 'login'});
                }
                else{
                    alert("Si è verificato un errore durante il caricamento");
                    console.error(error)
                }
            });
        },
        deletePet(){
            let vm = this;
            axios({
                method: "DELETE",
                url: vm.$API_BASE_URL + "deletePet.php",
                data: {
                    "petId":vm.$route.params.petId
                },
                headers: {
                    'Authentication-Token': window.localStorage.getItem("sogno_at")
                }
            })
            .then(function (response) {
                if (response.status == 200) {
                    vm.showDeletedToast = true;
                    vm.$router.push({name: 'customers'});
                } 
                else{
                    alert("Si è verificato un errore durante il caricamento");
                }
            })
            .catch(function (error) {
                if(error.response.status==403||error.response.status==401){
                    vm.$router.push({name: 'login'});
                }
                else{
                    alert("Si è verificato un errore durante il caricamento");
                    console.error(error)
                }
            });
        }
    }
}
</script>
